<template>
  <!-- background start -->
  <!-- <div class="login-container clear" id="Loginbackground" style="box-sizing: border-box;height:100vh"> -->
    <div class="login-container clear" style="background:url(./static/img/longinbg.jpg);box-sizing: border-box;height:100vh">

    <!-- loginform start -->
    <el-form ref="loginForm" class="loginform" style="width:360px; height:330px; background:#fff;" label-width="80px" :model="loginForm" :rules="loginRules">
      <!-- 头部 -->
      <div class="logtop" style="margin:28px 0">
        <img src="../../static/img/log.png" height="109" width="331" class="logimg">
        <br />
        <b></b>
      </div>
      <!-- 输入框 -->
      <el-form-item prop="user_code" class="userlog">
        <el-input placeholder="请输入用户编码" prefix-icon="iconfont icon-id" v-model="loginForm.user_code">
        </el-input>
      </el-form-item>
      <el-form-item prop="password" class="userlog">
        <el-input placeholder="请输入密码" prefix-icon="iconfont icon-psd" @keyup.enter.native="login('loginForm')" type="password" v-model="loginForm.password">
        </el-input>
      </el-form-item>
      <!--       <el-form-item  class="userlog">
       <el-select style="width: 300px;" @change="selectchange"  value-key="storecode" v-model="loginForm.storename" auto-complete="off">
                <el-option
                  v-for="item in storeList"
                  :key="item.storecode"
                  :label="item.storename"
                  :value="item">
                </el-option>
        </el-select>
      </el-form-item> -->
      <!-- 提交按钮 login('loginForm')-->
      <el-form-item class="sublog">
        <el-button type="primary" @click="login('loginForm')" class="but" v-loading.fullscreen.lock="fullscreenLoading">登录</el-button>
      </el-form-item>
    </el-form>
    <!-- loginform end -->
    <!-- 弹窗 start -->
    <MessageModel types="提示信息"
                  :msg="msg"
                  :flag="modelFlag"
                  :msgShow="msgShow"
                  :butmsg="butmsg"
                  :butflag = "butflag"
                  @modelmsg="returnMsg">
    </MessageModel>

  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    name: 'login',
    data() {
      const validateUserid = (rule, value, callback) => { // 账号规则
        if (value === '') {
          callback(new Error('请输入账号'));
        } else {
          callback();
        }
      };
      const validatePass = (rule, value, callback) => { //密码规则
        if (value.length < 6) {
          callback(new Error('密码不能小于6位'));
        } else if (value === '') {
          callback(new Error('密码不能为空'));
        } else {
          callback();
        }
      };
      return {
        modelFlag:false,
        modelFlag2:false,
        msgShow:false,
        butflag:true,
        butflag2:true,
        msg:'',
        butmsg:'确认',
        butmsg2:'确认',
        methodName:'',
        fullscreenLoading: false,
        // InterfacePath: 'http://120.55.71.77:8082/ktn',
        InterfacePath: 'http://127.0.0.1:8082/ktn',
        utilpath: '',
        // InterfacePath:'http:/192.168.0.112:8082/ktn',
        loginForm: { //登录数据49
          user_code: '',
          password: '',
          storecode: '',
          storename: ''
        },
        routers: '',
        storeList: [],
        loginRules: { //验证规则
          user_code: [
            { required: true, trigger: 'blur', validator: validateUserid }
          ],
          password: [
            { required: true, trigger: 'blur', validator: validatePass }
          ]
        },
        loading: false,
        showDialog: false,
        routerPathNum:'',
        userInfo: {
          menuStatus:'',
          storecode: '', //门店编码
          storename: '', //门店名称
          busilicense: '', //营业许可证
          email: '', //邮箱
          user_code: '', //门店用户编码
          user_name: '', //门店用户名称
          storehouse_code: '', //仓库编码
          storehouse_name: '', //仓库名称
          role_code: '', //角色编号
          role_name: '', //角色名称
          outtime: '', //超时
          localdate: '', //当前时间登陆
        },
      }
    },
     watch: {
          $route(to, from) {
            var path = to.path;
            var msg = this.$route.query.msg==null?'':this.$route.query.msg;
            if(msg == -1){
              this.$message({
                showClose: true,
                message: '请先登录再访问页面',
                type: 'warning'
              });
            }
          }
    },
    mounted() {
      this.utilpath = axios.defaults.baseURL;
      console.log("登录内打印接口" + this.utilpath);
      // this.getstore();
      /*页面挂载获取cookie，如果存在username的cookie，则跳转到主页，不需登录*/
      var msg = this.$route.query.msg;
      if (msg == 0) {
        this.fullscreenLoading = false;
        this.$router.push({ path: '/ui/login' });
        // window.location.reload();
        this.$message({
          showClose: true,
          message: '登录已超时请重新登录',
          type: 'warning'
        });
      }else if(msg == -1){
         // window.location.reload();
         this.$router.push({path:'/ui/login'});
        this.fullscreenLoading = false;
        this.$message({
          showClose: true,
          message: '请先登录在访问页面',
          type: 'warning'
        });
      }else if(msg == 9){
        this.fullscreenLoading = false;
        this.$router.push({path:'/ui/login'});
        this.fullscreenLoading = false;
        this.$message({
          showClose: true,
          message: '用户信息已失效，需重新登录',
          type: 'warning'
        });
      }else if(msg == 2){
        this.$router.push({path:'/ui/login'});
        this.fullscreenLoading = false;
        this.$message({
          showClose: true,
          message: '您已被他人强制退出，需重新登录',
          type: 'warning'
        });
      this.loginout();
      }
      var userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
      // console.log("打印当前时间："+parseInt(Date.parse(new Date())));
    },
    methods: {
      loginout() {
    /*删除cookie*/
    // delCookie('user_code');

    //获取数据接口
    this.$http.post(this.utilpath+'/loginOut',{emulateJSON:true}).then((res) => {
     // console.log("打印退出返回结果:"+JSON.stringify(res.data));
        if(res.data.status == '0'){
            sessionStorage.clear();
            window.localStorage.clear();
            this.$router.push({
              path:'/ui/login'
            });
        }else{
          this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow =false;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
        }

    }, (err) => {
        this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = '连接退出接口失败';
          this.butflag =false;
          this.butmsg='知道了';
        console.log(err);
    });

  },
      getNewrouter(){
        this.$http.post(this.utilpath + '/selectMenu', { emulateJSON: true,_timeout:600 }).then((res) => {
              // console.log("打印返回值res.data" + JSON.stringify(res.data));
              // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
              if (res.data.status == '0') {
                 this.fullscreenLoading = false;
                 if(this.userInfo.role_name=='门店管理员'){
                     this.routers = res.data.resultList[0].children;

                 }else{
                  this.routers = res.data.resultList[1].children;
                     // this.openindex.push(this.routers[0].pk_menu);
                 }
                 window.localStorage.setItem("routers", JSON.stringify(this.routers));
                 // console.log("打印菜单列表this.routers" + JSON.stringify(this.routers));
                 // console.log("打印菜单列表this.openindex" + JSON.stringify(this.openindex));
              } else if (res.data.status == '-1') {
                this.routers =[];
                this.fullscreenLoading = false;
                this.$message({
                  showClose:true,
                  message:'暂无菜单数据',
                  type:'info'
                })
                this.count = res.data.countNum;
                // console.log("-----暂无数据！！！");
              } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
            } else {
                    this.fullscreenLoading = false;
                    this.modelFlag = true;
                    this.msgShow = true;
                    this.methodName = 'message';
                    this.msg = res.data.message;
                    this.butflag =false;
                    this.butmsg='知道了';
            }
            }, (err) => {
              this.fullscreenLoading = false;
              this.msgShow =false;
              this.modelFlag = true;
              this.methodName = 'message';
              this.msg = '连接获取所以菜单信息接口失败';
              this.butflag =false;
              this.butmsg='知道了';
              console.log(err);
          });
      },
      returnMsg(flag){
        this.modelFlag = false;
        if(flag){
          // console.log("---进来了！！！----"+this.methodName);
          if(this.methodName =='login'){
            this.$http.post(this.utilpath + '/login', this.loginForm,  { emulateJSON: true,_timeout:300}).then((res) => {
              if (res.data.status == '1') {
                this.fullscreenLoading = false;
                this.$message({
                  showClose: true,
                  message: '用户编号或密码错误',
                  type: 'warning'
                });
              }else if (res.data.status == '0'){
                this.fullscreenLoading = false;
                window.localStorage.setItem("InterfacePath", this.InterfacePath);
                this.userInfo = res.data.result;
                 this.userInfo.menuStatus = res.data.menuStatus;
                sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
                window.localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
                this.routers = res.data.result.router;
                window.localStorage.setItem("routers", JSON.stringify(this.routers));
                // console.log("打印地址去向："+res.data.menuStatus);
                this.$router.push({ path: res.data.menuStatus}); //跳转页面
              } else {
                this.fullscreenLoading = false;
                this.modelFlag = true;
                this.msgShow = true;
                this.methodName = 'message';
                this.msg = res.data.message;
                this.butflag =false;
                this.butmsg='知道了';
              }
            }, (err) => {
              this.fullscreenLoading = false;
              this.msgShow = false;
              this.modelFlag = true;
              this.methodName = 'message';
              this.msg = '调用登录接口失败';
              this.butflag =false;
              this.butmsg='知道了';
            });
          }
        }else{
          this.$message({
            showClose:true,
            message:'已取消',
            type:'succcess'
          })
        }
      },
      getstore() {
        //获取数据接口this.InterfacePath+
        this.$post('/selectStore', {}).then((res) => {
          // console.log("-=-=-=-=-" + JSON.stringify(res));
          // this.$http.post('/ktnapi/selectStore',{emulateJSON:true}).then((res) => {
          // this.$http.post('ktnapi/selectStore',{emulateJSON:true}).then((res) => {
          if (res.data.status == '0') {
            var stores = res.data.resultList;
            this.storeList = [];
            for (var i = stores.length - 1; i > -1; i--) {
              this.storeList.push({ storename: stores[i].storename, storecode: stores[i].storecode });
            }
          } else if (res.data.status == '-1') {
            this.storeList = [];
            this.$message({
              showClose:true,
              message:'暂无门店数据',
              type:'info'
            })
          } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了';
          }

        }, (err) => {
          this.modelFlag = true;
          this.msgShow = false;
          this.methodName = 'message';
          this.msg = '调用获取门店接口失败';
          this.butflag =false;
          this.butmsg='知道了';
        });
      },
      selectchange(value) {
        // console.log("下拉变化事件" + JSON.stringify(value) + "下标：");
        this.loginForm.storecode = value.storecode;
        this.loginForm.storename = value.storename;
      },
      getrouter() {
        var reqParams2 = {
          user_code: this.loginForm.user_code,
        };
        //this.$http.post('api/router1')
        // if(this.loginForm.user_code =='cfx'){
        //         this.utilpath = 'http://192.168.0.109:8082/ktn'
        //     }
        this.$http.post(this.utilpath+'/getUserRouterList', reqParams2, { emulateJSON: true,_timeout:600 })
        // this.$post('/getUserRouterList', reqParams2,{emulateJSON:true})
        // this.$http.post(this.InterfacePath+'/getUserRouterList', reqParams2,{emulateJSON:true})
        //this.$http.post('ktnapi//getUserRouterList', reqParams,{emulateJSON:true})
          .then((res) => {
            var status = res.data.status;
            if (status == "0") {
              //this.routers = res.data.result;
              this.routers = res.data.resultList;
              var path = this.$route.path;
              this.routers.forEach((item) => {
                if (item.grade == "1" && item.path == path) {
                  item.active = true;
                } else if (item.grade == "1" && item.path != path) {
                  item.active = false;
                }
              });
              window.localStorage.setItem("routers", JSON.stringify(this.routers));
              this.fullscreenLoading = false;
              // console.log("打印地址去向判断"+this.routerPathNum);
              if(res.data.result=='0'){
                this.$router.push({ path: '/ui/system/authority' }); //跳转页面
              }else{
                this.$router.push({ path: '/ui' }); //跳转页面
              }
            } else if (status == "-1") {
              this.fullscreenLoading = false;
              this.$message({
                showClose:true,
                message:'没有获取到菜单',
                type:'info'
              })
            } else {
              this.fullscreenLoading = false;
              this.modelFlag = true;
              this.msgShow = true;
              this.methodName = 'message';
              this.msg = res.data.message;
              this.butflag =false;
              this.butmsg='知道了';
            }
          }, (err) => {
            this.fullscreenLoading = false;
            this.modelFlag = true;
            this.msgShow = false;
            this.methodName = 'message';
            this.msg = '调用菜单接口失败';
            this.butflag =false;
            this.butmsg='知道了';
          });
      },
      login(formName) { //登录方法
        sessionStorage.clear();
        this.$refs[formName].validate((valid) => {
          if (valid) { //满足规则
            this.fullscreenLoading = true;
            // console.log("this.loginForm" + JSON.stringify(this.loginForm));
            var users = JSON.stringify(this.loginForm);
            // const root = process.env.API_ROOT;
            // http://192.168.1.134:8082/test this.InterfacePath+this.InterfacePath+
            // this.$post('/login',this.loginForm).then((res) => {

            // if(this.loginForm.user_code =='cfx'){
            //     this.utilpath = 'http://192.168.0.109:8082/ktn'
            // }
            // console.log("login方法内的接口路径："+this.utilpath+ '/login');
            this.$http.post(this.utilpath + '/login', this.loginForm,  { emulateJSON: true }).then((res) => {
              // this.$http.post('/ktnapi/login',this.loginForm,{emulateJSON:true}).then((res) => {
              if (res.data.status == '1') {
                this.fullscreenLoading = false;
                this.$message({
                  showClose: true,
                  message: '用户编号或密码错误',
                  type: 'warning'
                });

              } else if(res.data.status == '2'){
                this.modelFlag = true;
                this.msgShow = false;
                this.methodName = 'login';
                this.msg = '已有人在登录中，是否强制登录？';
                this.butflag =true;
                this.butmsg='登录';

              }else if (res.data.status == '0'){
                window.localStorage.setItem("InterfacePath", this.InterfacePath);
                this.userInfo = res.data.result;
                this.userInfo.menuStatus = res.data.menuStatus;
                sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
                window.localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
                // console.log("set打印vuex1："+JSON.stringify(this.$store.state.userInfo));
                // this.$store.commit('SWITCHSHOW',this.userInfo);
                // console.log("set打印vuex2："+JSON.stringify(this.$store.state.userInfo));
                // this.fullscreenLoading = false;
                // this.getrouter();
                // this.getNewrouter();
                this.routers = res.data.result.router;
                window.localStorage.setItem("routers", JSON.stringify(this.routers));
                // console.log("打印登录路由："+JSON.stringify( res.data.result.router));
                this.fullscreenLoading = false;
                // console.log("打印地址去向："+res.data.menuStatus);
                this.$router.push({ path: res.data.menuStatus}); //跳转页面
              } else {
                this.fullscreenLoading = false;
                this.modelFlag = true;
                this.msgShow = true;
                this.methodName = 'message';
                this.msg = res.data.message;
                this.butflag =false;
                this.butmsg='知道了';
              }
            }, (err) => {
              this.fullscreenLoading = false;
              this.modelFlag = true;
              this.msgShow = false;
              this.methodName = 'message';
              this.msg = '调用登录接口失败了-'+JSON.stringify(err);
              this.butflag =false;
              this.butmsg='知道了';
            });
          } else { //不满足
            this.fullscreenLoading = false;
            return false;
          }
        });
      },
    }
  }

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/index.vue